import { render, staticRenderFns } from "./tambah-broadcast.vue?vue&type=template&id=47ac6ae3&"
import script from "./tambah-broadcast.vue?vue&type=script&lang=js&"
export * from "./tambah-broadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports